import { StartupService } from './startup.service';
import { ComponentMap } from '../models/component.map';
import { Location, PopStateEvent } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Answers } from '../models/answers.model';
import { AppHistory } from '../models/app-history.model';
import { QaService } from './qa.service';
import { VisualizerService } from './visualizer.service';
import { BehaviorSubject } from 'rxjs';
import { AnswerInfoService } from './answer-info.service';

@Injectable()
export class HistoryService {
  public history: AppHistory[] = new Array<AppHistory>();
  answerConfirmationShown: boolean;
  stepsCompleted: number = 2;

  private selectedWoodTypeSource = new BehaviorSubject<string>(null);
  selectedWoodType = this.selectedWoodTypeSource.asObservable();

  constructor(
    private startupService: StartupService,
    private location: Location,
    private router: Router,
    private qaService: QaService,
    private route: ActivatedRoute,
    private visualizerService: VisualizerService,
    private answerInfoService: AnswerInfoService
  ) {
    const emptyHistory = new AppHistory('/', new Answers());
    this.history.push(emptyHistory);
  }

  next(url: string, answers?: Answers) {
    if (this.history.find(x => x.url === url) == null) {
      const newAnswersObject = JSON.parse(JSON.stringify(answers));
      const newHistoryObject = new AppHistory(url, { ...newAnswersObject });
      this.history.push(newHistoryObject);
    }

    this.selectedWoodType.subscribe(w => {
      if (w !== this.answerInfoService.getSelectedWoodType()) {
        this.visualizerService.setSelectedColor(null);
      }
    });
  }

  setSelectedWoodType(woodType: string) {
    this.selectedWoodTypeSource.next(woodType);
  }

  back() {

  }

  addStep() {
    this.stepsCompleted = this.stepsCompleted + 1;
  }

  getCompletedSteps() {
    return this.stepsCompleted;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/history.service.ts